<template>
	<div>
		<el-select
		:value="curPetId"
		@change="change"
		style="width:100%"
		filterable
		remote
		:disabled="disabled"
		reserve-keyword
		placeholder="请输入宠物昵称"
		:remote-method="remoteMethodPet">
			<el-option
			v-for="(item) in petList" :key="item.pet_id"
			:label="item.pet_name+' ('+item.category_info.name+' '+item.member_name+' '+item.member_mobile+')'"
			:value="item.pet_id">
			</el-option>
			<template slot="empty">
				<div style="width:300px;font-size: 14px;color:red;text-align: center;padding:10px 0;">没有宠物信息，请创建客户档案</div>
			</template>
		</el-select>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				petList:[],
				curPetId:'',
			}
		},
		props:{
			propsPetList:{
				default:()=>{
					return {}
				}
			},
			disabled:{
				default:false
			}
		},
		watch:{
			propsPetList(n){
				if(n===''){
					this.petList=[];
					this.curPetId=''
				}else{
					if(n._id){
						n.pets_info = n.pets_info.filter(e=>e.status.value==='1')
						if(n.pets_info[0]){
							if((n.pets_info[0]._id!==this.curPetId)){
								this.curPetId = n.pets_info[0]?n.pets_info[0]._id:''
								this.petList = []
								for(let i=0;i<n.pets_info.length;i++){
									this.petList.push({
										apply_type:n.pets_info[i].apply_type,
										category_info:n.pets_info[i].category_info,
										hs_pet: n.pets_info[i].hs_pet,
										member_id:n._id,
										member_mobile: n.basic_info.user_mobile,
										member_name: n.basic_info.nick_name,
										member_type: n.club_card. surplus_day,
										member_yue: n.card_info.user_yue,
										member_zenge: n.card_info.user_zenge,
										pet_birthday: n.pets_info[i].bron_date,
										pet_class: null,
										pet_id: n.pets_info[i]._id,
										pet_name: n.pets_info[i].nick_name,
										pet_sex: n.pets_info[i].pet_sex,
										pet_sterilization: n.pets_info[i].sterilization,
										
										// "member_id":n._id,
										// "member_name":n.basic_info.nick_name,
										// "member_mobile":n.basic_info.user_mobile,
										// "member_type":n.club_card. surplus_day,
										// "member_yue":n.card_info.user_yue,
										// "member_zenge":n.card_info.user_zenge,
										// "pet_id":n.pets_info[i]._id,
										// "pet_name":n.pets_info[i].nick_name,
										// "pet_type":n.pets_info[i].type_name,
										// "pet_class":n.pets_info[i].class_name,
										// "class_type":n.pets_info[i].class_type,
										// "pet_birthday":n.pets_info[i].birth_day,
										// "pet_sex":n.pets_info[i].sex,
										// "pet_sterilization":n.pets_info[i].sterilization,
										// "hs_pet":n.pets_info[i].hs_pet,
									})
								}
								this.change(this.curPetId)
								console.log(this.petList,this.curPetId)
							}
						}else{
							this.curPetId=''
							this.petList=[]
							this.change(this.curPetId)
						}
					}else{
						this.petList=[];
						this.curPetId=''
					}
				}
			}
		},
		computed:{
			curPet(){
				return this.petList.filter(item=>{return item.pet_id==this.curPetId});
			},
		},
		mounted(){
		},
		methods: {
			change(id){
				this.curPetId = id
				if(this.curPet[0]){
					this.$emit("getCurPetItem",this.curPet[0])
				}else{
					this.$emit("getCurPetItem",'')
				}
			},
			// 下拉改变
			// visibleChange(a) {
			// 	if (a) {
			// 		this.remoteMethodPet('');
			// 	}
			// },
			remoteMethodPet(str){
				this.$util.getPetList(str).then(list=>{
					this.petList = list
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	
</style>
